// extracted by mini-css-extract-plugin
var _1 = "ReactionAvatarStack-module__additionalNode--WNmAa";
var _2 = "ReactionAvatarStack-module__animateUploadProgressBarWidth--xXSuo";
var _3 = "ReactionAvatarStack-module__animatedBackground--NMxLS";
var _4 = "ReactionAvatarStack-module__avatarContainer--bv2wb";
var _5 = "ReactionAvatarStack-module__avatarStackItemContainer--HyZzC";
var _6 = "ReactionAvatarStack-module__container--jYqLd";
var _7 = "ReactionAvatarStack-module__counter--MegxT";
var _8 = "ReactionAvatarStack-module__last--AiPtA";
var _9 = "ReactionAvatarStack-module__loose--KCgi7";
var _a = "ReactionAvatarStack-module__overlapAdditionalNode--EdikY";
var _b = "ReactionAvatarStack-module__visible--kkPoD";
var _c = "ReactionAvatarStack-module__withinOverlay--wB45a";
var _d = "ReactionAvatarStack-module__wrap--sZzUD";
export { _1 as "additionalNode", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "avatarContainer", _5 as "avatarStackItemContainer", _6 as "container", _7 as "counter", _8 as "last", _9 as "loose", _a as "overlapAdditionalNode", _b as "visible", _c as "withinOverlay", _d as "wrap" }
